import Popup from './Popup.vue';

export default {
  install(Vue) {
    // 
    const PopupConstructor = Vue.extend(Popup);
    // 
    const instance = new PopupConstructor(111);
    // 
    instance.$mount(document.createElement('div'));
    document.body.appendChild(instance.$el);
    // 
    Vue.prototype.$toast = args => {
      let newOpts = { visible: true, mode: 'toast', autoClose: true };
      if (typeof args == "string") newOpts.message = args;
      if (typeof args == "object") newOpts = Object.assign({}, newOpts, args);
      //
      instance.initWithParams(newOpts);
    };
    // 
    Vue.prototype.$message = args => {
      let newOpts = { visible: true, mode: 'message', autoClose: true };
      if (typeof args == "string") newOpts.message = args;
      if (typeof args == "object") newOpts = Object.assign({}, newOpts, args);
      //
      instance.initWithParams(newOpts);
    };
    // 
    Vue.prototype.$tooltip = args => {
      let newOpts = { visible: true, mode: 'tooltip', autoClose: true };
      if (typeof args == "string") newOpts.message = args;
      if (typeof args == "object") newOpts = Object.assign({}, newOpts, args);
      //
      instance.initWithParams(newOpts);
    };
    // 
    Vue.prototype.$loading = args => {
      let newOpts = { visible: true, mode: 'loading', maskClickable: false, autoClose: false };
      if (typeof args == "string") newOpts.message = args;
      if (typeof args == "object") newOpts = Object.assign({}, newOpts, args);
      //
      instance.initWithParams(newOpts);
    };
    // 
    Vue.prototype.$alert = args => {
      return new Promise((resolve) => {
        let newOpts = { visible: true, mode: 'alert', maskClickable: false, closable: true, showCancel: false };
        if (typeof args == "string") newOpts.message = args;
        if (typeof args == "object") newOpts = Object.assign({}, newOpts, args);
        //
        instance.initWithParams(newOpts);
        //
        instance.btnClickHandler = () => {
          typeof newOpts.success == "function" && newOpts.success();
          resolve(true);
        };
      });
    };
    // 
    Vue.prototype.$confirm = args => {
      return new Promise((resolve, reject) => {
        let newOpts = { visible: true, mode: 'confirm', maskClickable: false, closable: true, showCancel: true };
        if (typeof args == "string") newOpts.message = args;
        if (typeof args == "object") newOpts = Object.assign({}, newOpts, args);
        //
        instance.initWithParams(newOpts);
        //
        instance.btnClickHandler = type => {
          if (type == 'confirm') {
            typeof newOpts.success == "function" && newOpts.success();
            resolve(true);
          } else {
            typeof newOpts.failure == "function" && newOpts.failure();
            reject(false);
          }
        };
      });
    };
    // 
    Vue.prototype.$prompt = args => {
      return new Promise((resolve, reject) => {
        let newOpts = { visible: true, mode: 'prompt', maskClickable: false, closable: true, showCancel: true };
        if (typeof args == "string") newOpts.message = args;
        if (typeof args == "object") newOpts = Object.assign({}, newOpts, args);
        //
        instance.initWithParams(newOpts);
        //
        instance.btnClickHandler = (type, res) => {
          if (type == 'confirm') {
            typeof newOpts.success == "function" && newOpts.success(res);
            resolve(res);
          } else {
            typeof newOpts.failure == "function" && newOpts.failure(res);
            reject(res);
          }
        };
      });
    };
    // 
    Vue.prototype.$dialog = args => {
      console.info(args);
    };
    // 
    Vue.prototype.$modal = args => {
      console.info(args);
    };
    // 
    Vue.prototype.$popup = args => {
      console.info(args);
    };
  }
};